export default {
  fields: {
    user_id: {
      readOnly: true,
    },
    issuer_id: {
      readOnly: true,
    },
    issuer_type: {
      readOnly: true,
    },
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    }
  },
  relationships: {
    user: {
      type: 'users',
    },
    issuer: {
      polymorphic: true,
    }
  }
}
